export interface Game {
  id: string;
  title: string;
  category: string;
  image: string;
  description?: string;
  isNew?: boolean;
  isHot?: boolean;
  apiGameId?: number;
  externalUrl?: string;
  orientation?: 'portrait' | 'landscape';
}

export const games: Game[] = [
  {
    id: 'PickaxeQuest',
    title: 'Pickaxe Quest',
    category: 'Adventure',
    image: '/images/games/PickaxeQuest.jpg',
    description: 'Mining and adventure game',
    isNew: true,
    isHot: false,
    apiGameId: 70,
    externalUrl: 'https://games.playsout.com/demo/PickaxeQuest1/',
    orientation: 'portrait',
  },
  {
    id: 'CapybaraLink',
    title: 'Capybara Link',
    category: 'Puzzle',
    image: '/images/games/CapybaraLink.jpg',
    isNew: true,
    isHot: false,
    apiGameId: 10,
    externalUrl: 'https://games.playsout.com/demo/CapybaraLink1/',
    orientation: 'portrait',
  },
  {
    id: 'ProjectGarden',
    title: 'Project: Garden',
    category: 'Adventure',
    image: '/images/games/SimulatedAdventures.jpg',
    isNew: true,
    isHot: false,
    apiGameId: 79,
    externalUrl: 'https://games.playsout.com/demo/Garden1/',
    orientation: 'portrait',
  },
  {
    id: 'MushroomWarriors',
    title: 'Mushroom Warriors',
    category: 'RPG',
    image: '/images/games/MushroomWarriors.jpg',
    isNew: true,
    isHot: false,
    apiGameId: 80,
    externalUrl: 'https://games.playsout.com/demo/MushroomWarriors/',
    orientation: 'portrait',
  },
  {
    id: 'OneDoor',
    title: 'One Door',
    category: 'Arcade',
    image: '/images/games/OneDoor.jpg',
    isNew: true,
    isHot: false,
    apiGameId: 20,
    externalUrl: 'https://games.playsout.com/demo/OneDoor/',
    orientation: 'portrait',
  },
  {
    id: 'Falling2048',
    title: 'Falling 2048',
    category: 'Casual',
    image: '/images/games/Falling2048.jpg',
    isNew: true,
    isHot: false,
    apiGameId: 52,
    externalUrl: 'https://games.playsout.com/demo/Falling20481/',
    orientation: 'portrait',
  },
  {
    id: 'SaveTheKing',
    title: 'Save The King',
    category: 'Moba',
    image: '/images/games/savetheking.jpg',
    description: 'Strategy game, protect the king from enemy attacks',
    isNew: true,
    apiGameId: 73,
    orientation: 'portrait',
  },
  {
    id: 'FishTankFury',
    title: 'Fish Tank Fury',
    category: 'Puzzle',
    image: '/images/games/FishTankFury.jpg',
    description: 'Fish tank game',
    isNew: true,
    isHot: false,
    apiGameId: 2,
    externalUrl: 'https://games.playsout.com/demo/FishTankFury2/',
    orientation: 'portrait',
  },
  {
    id: 'KittyEscape',
    title: 'Kitty Escape',
    category: 'Puzzle',
    image: '/images/games/KittyEscape.jpg',
    description: 'Help the cat escape the maze',
    isNew: true,
    isHot: true,
    apiGameId: 1,
    externalUrl: 'https://games.playsout.com/demo/KittyEscape/',
    orientation: 'portrait',
  },
  {
    id: 'KittyCrushSaga',
    title: 'Kitty Crush Saga',
    category: 'Arcade-Puzzle',
    image: '/images/games/Kitty Crush Saga.jpg',
    description: 'Puzzle game',
    apiGameId: 3,
    externalUrl: 'https://games.playsout.com/demo/KittyCrushSaga/',
    orientation: 'portrait',
  }
];

// 按类别分组的游戏
export const gamesByCategory = {
  'Adventure': games.filter(game => game.category === 'Adventure'),
  'RPG': games.filter(game => game.category === 'RPG'),
  'Arcade': games.filter(game => game.category === 'Arcade'),
  'Casual': games.filter(game => game.category === 'Casual'),
  'Moba': games.filter(game => game.category === 'Moba'),
  'Puzzle': games.filter(game => game.category === 'Puzzle'),
  'Arcade-Puzzle': games.filter(game => game.category === 'Arcade-Puzzle'),
};

// 获取新游戏
export const getNewGames = (): Game[] => {
  return games.filter(game => game.isNew);
};

// 获取热门游戏
export const getHotGames = (): Game[] => {
  return games.filter(game => game.isHot);
};

// 根据ID获取游戏
export const getGameById = (id: string): Game | undefined => {
  const targetId = id.toLowerCase();
  return games.find(game => game.id.toLowerCase() === targetId);
};

// 根据游戏ID获取 API 游戏ID
export const getApiGameId = (id: string): number | undefined => {
  const targetId = id.toLowerCase();
  const game = games.find(item => item.id.toLowerCase() === targetId);
  return game?.apiGameId;
};

// 获取所有游戏类别
export const getAllCategories = (): string[] => {
  return Array.from(new Set(games.map(game => game.category)));
}; 
